import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgCrown = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17 * (props.wx ?? 1)}
    height={27 * (props.hx ?? 1)}
    viewBox="0 0 17 27"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinejoin="round"
      d="M8.61 1.805c-1.333 0-4.8-1.923-6.801.176-1.605 1.683-1.012 5.73.138 8.454.427 1.013.409 2.269.323 3.443-.343 4.702 1.19 11.94 2.593 11.856 1.438-.088 1.309-8.708 3.48-9.46 1.267-.439 1.563 1.821 1.845 3.938.336 2.532.138 5.176.853 5.448.834.315 2.414-1.805 3.254-5.656.451-2.07.646-4.408.588-6.097-.037-1.094-.038-2.459.39-3.472 1.15-2.723 1.742-6.77.138-8.453-2.002-2.1-5.469-.177-6.802-.177Z"
    />
    <path
      fill={props.findingsFill || '#FF5140'}
      d="M2.217 2.316C4.152.205 7.502 2.14 8.791 2.14s4.714-2 6.573.178c1.463 1.715.963 5.215.463 6.215-.413 1.018-5.816 0-7 0-1 0-6.586 1.019-7 0-.5-.5-1.16-4.524.39-6.216"
    />
  </svg>
);
export default SvgCrown;
